import React from "react";
import { ModalType, useModal } from "../../../../Context/ModalContext";
import { useAppSelector } from "../../../../hook/redux";


function BackgroundSelector(  ) {
  const { carteId, preloadCard } = useAppSelector((state) => state.editor.loadInPageMultimgEditor)

  const { toggleShow } = useModal();

  return (
      <div className="toolbar-button"
           data-carte-id={ carteId }
           data-bg-selected={ preloadCard }
           onClick={ () => {toggleShow( true, null, ModalType.background );} }
           data-test={"layout-background"}
      >
        <i className="fas fa-fill-drip"></i>
      </div>
      );
      }
      export default BackgroundSelector;